module.exports = __webpack_public_path__ + "static/media/contact-img.10841f42.png";